// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__82qAT","page":"Pagination_page__yjDIP","pageActive":"Pagination_pageActive__B4FKm","more":"Pagination_more__4-ToH"};